<template>
  <div id="choose-quotation-action">
    <Header />
    <div class="uk-card uk-padding uk-flex uk-flex-center uk-animation-fade" uk-height-viewport>
      <div class="uk-container uk-container">
        <div class="uk-grid-margin uk-grid uk-grid-stack uk-text-center" uk-grid>
          <h3
            class="uk-card-title uk-text-center uk-text-bold uk-margin-remove-bottom"
          >Que souhaitez-vous faire ?</h3>
        </div>
        <div
          class="uk-grid-margin uk-grid uk-grid-stack uk-text-center uk-margin-remove-top"
          uk-grid
        ></div>

        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
          <div class="uk-width-auto" uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
            <div
              class="uk-width-large uk-card uk-card-primary uk-box-shadow-medium uk-border-rounded uk-card-hover"
            >
              <router-link to="/create-quotation">
                <img
                  class="uk-height-medium uk-flex uk-background-cover uk-light"
                  src="../assets/estimate.png"
                />
                <h1
                  class="uk-text-center uk-text-middle uk-text-large uk-text-bolder uk-margin-bottom uk-text-uppercase"
                >Obtenir un devis</h1>
              </router-link>
            </div>
          </div>

          <div class="uk-width-auto" uk-scrollspy="cls: uk-animation-slide-right; repeat: true">
            <div
              class="uk-width-large uk-card uk-card-primary uk-box-shadow-medium uk-border-rounded uk-card-hover"
            >
              <router-link to="/get-quotation">
                <img
                  class="uk-height-medium uk-flex uk-background-cover uk-light"
                  src="../assets/invoices.png"
                />
                <h1
                  class="uk-text-center uk-text-middle uk-text-large uk-text-bolder uk-margin-bottom uk-text-uppercase"
                >Régler un devis</h1>
              </router-link>
            </div>
          </div>
        </div>
        <router-link to="/login">
          <button
            class="uk-button uk-button-default uk-border-rounded uk-text-bold uk-margin-large-top"
            type="button"
          >Créer un compte</button>
        </router-link>
        <p
          class="uk-heading-xsmall uk-text-center uk-text-bolder"
        >Créer un compte vous permettra de gagner du temps lorsque vous voudrez régler votre devis.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";

export default {
  name: "ChooseQuotationAction",
  components: {
    Header
  },
  data() {
    return {
      currentUser: {}
    };
  },

  mounted() {
    if (localStorage.getItem("currentUser")) {
      try {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
      } catch (e) {
        localStorage.removeItem("currentUser");
      }
    }

  },

  methods: {
    addDelivery: function() {}
  }
};
</script>


<style scoped>
a {
  text-decoration: none;
}

.uk-card-primary {
  background-color: #309eb5;
}

.uk-card-primary:hover {
  background-color: #234b70;
}
</style>